export var FTMarketIds = {
    ML: ["1_39", "1_0"],
    HC: ["2_39", "2_0"],
    OU: ["3_39", "3_0"]
};
//# sourceMappingURL=FTMarketIds.js.map